import { NgTemplateOutlet } from '@angular/common';
import type { TemplateRef } from '@angular/core';
import { Component, input, ChangeDetectionStrategy } from '@angular/core';

export type CandidateFieldRow = {
  value: string;
  isValid?: boolean;
};

@Component({
  selector: 'rt-candidate-field-row-simple',
  imports: [NgTemplateOutlet],
  templateUrl: './candidate-field-row-simple.component.html',
  styleUrl: './candidate-field-row-simple.component.less',
  changeDetection: ChangeDetectionStrategy.Eager,
  host: {
    '[class.context-private]': 'isPrivate()',
    '[class.no-padding]': 'noPadding()',
  },
})
export class CandidateFieldRowSimpleComponent {
  public name = input.required<string>();
  public value = input<string>();
  public isPrivate = input<boolean>(false);
  public noPadding = input<boolean>(false);
  public fieldDisplayTpl = input<TemplateRef<any>>();
}
